// Content types requested for each tab of /projetos-externos (tab ids are the PT-BR labels).
export const EXTERNAL_PROJECTS_TAB_TYPES = {
  Todos: ["Dramaturgy", "Variety"],
  Dramaturgia: ["Dramaturgy"],
  Variedades: ["Variety"],
};
